// src/utils/slugify.js
export function slugify(str = "") {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")    // remove non-word chars
    .replace(/\s+/g, "-")        // spaces -> dash
    .replace(/--+/g, "-");       // collapse multiple dashes
}
